var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04671 11.5534C8.07171 10.5784 7.33671 9.48674 6.84837 8.37924C6.74504 8.14507 6.80587 7.8709 6.98671 7.69007L7.66921 7.0084C8.22837 6.44924 8.22837 5.6584 7.74004 5.17007L6.76171 4.19174C6.11087 3.5409 5.05587 3.5409 4.40504 4.19174L3.86171 4.73507C3.24421 5.35257 2.98671 6.2434 3.15337 7.12674C3.56504 9.30424 4.83004 11.6884 6.87087 13.7292C8.91171 15.7701 11.2959 17.0351 13.4734 17.4467C14.3567 17.6134 15.2475 17.3559 15.865 16.7384L16.4075 16.1959C17.0584 15.5451 17.0584 14.4901 16.4075 13.8392L15.43 12.8617C14.9417 12.3734 14.15 12.3734 13.6625 12.8617L12.91 13.6151C12.7292 13.7959 12.455 13.8567 12.2209 13.7534C11.1134 13.2642 10.0217 12.5284 9.04671 11.5534Z",
    stroke: "url(#paint0_linear_549_40400)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_549_40400",
    x1: 6.20694,
    y1: 3.70361,
    x2: 14.7278,
    y2: 4.76204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4904D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelIcon);
export default __webpack_public_path__ + "static/media/tel-icon.49c332af8f4fa4ebea103250faedb6af.svg";
export { ForwardRef as ReactComponent };